import React, { useState } from 'react';
import { ArrowLeftIcon, PlusIcon, ArrowDownIcon, ArrowUpIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';
import { BottomNav } from '../components/BottomNav';
export const Wallet: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('rm');
  const wallets = {
    rm: {
      balance: 120.5,
      currency: 'RM',
      transactions: [{
        id: '1',
        type: 'topup',
        amount: 50,
        date: '2023-06-01',
        description: 'Wallet Top Up'
      }, {
        id: '2',
        type: 'ride',
        amount: -85,
        date: '2023-05-30',
        description: 'JB → Singapore'
      }, {
        id: '3',
        type: 'topup',
        amount: 100,
        date: '2023-05-28',
        description: 'Wallet Top Up'
      }]
    },
    sgd: {
      balance: 35.2,
      currency: 'SGD',
      transactions: [{
        id: '1',
        type: 'ride',
        amount: -25,
        date: '2023-05-29',
        description: 'Singapore → JB'
      }, {
        id: '2',
        type: 'topup',
        amount: 50,
        date: '2023-05-25',
        description: 'Wallet Top Up'
      }]
    }
  };
  const activeWallet = activeTab === 'rm' ? wallets.rm : wallets.sgd;
  return <div className="min-h-screen bg-background pb-16" data-id="element-649">
      <div className="p-6" data-id="element-650">
        <div className="flex items-center mb-6" data-id="element-651">
          <button className="p-2 mr-3" onClick={() => navigate(-1)} data-id="element-652">
            <ArrowLeftIcon size={24} data-id="element-653" />
          </button>
          <h1 className="text-xl font-semibold" data-id="element-654">My Wallet</h1>
        </div>
        <div className="flex mb-6 bg-card rounded-lg p-1" data-id="element-655">
          <button className={`flex-1 py-2 rounded-md text-center ${activeTab === 'rm' ? 'bg-primary text-background' : ''}`} onClick={() => setActiveTab('rm')} data-id="element-656">
            RM Wallet
          </button>
          <button className={`flex-1 py-2 rounded-md text-center ${activeTab === 'sgd' ? 'bg-primary text-background' : ''}`} onClick={() => setActiveTab('sgd')} data-id="element-657">
            SGD Wallet
          </button>
        </div>
        <div className="card mb-6" data-id="element-658">
          <p className="text-sm text-white text-opacity-70" data-id="element-659">
            Available Balance
          </p>
          <div className="flex items-center justify-between mt-2" data-id="element-660">
            <h2 className="text-3xl font-bold text-primary" data-id="element-661">
              {activeWallet.currency} {activeWallet.balance.toFixed(2)}
            </h2>
            <Button variant="secondary" className="py-2 px-4 w-auto flex items-center" data-id="element-662">
              <PlusIcon size={18} className="mr-1" data-id="element-663" />
              Top Up
            </Button>
          </div>
        </div>
        <div className="mb-6" data-id="element-664">
          <h2 className="text-lg font-medium mb-3" data-id="element-665">Transaction History</h2>
          <div className="space-y-3" data-id="element-666">
            {activeWallet.transactions.map(transaction => <div key={transaction.id} className="card" data-id="element-667">
                <div className="flex items-center" data-id="element-668">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center mr-3 ${transaction.type === 'topup' ? 'bg-green-500 bg-opacity-20' : 'bg-red-500 bg-opacity-20'}`} data-id="element-669">
                    {transaction.type === 'topup' ? <ArrowDownIcon size={20} className="text-green-500" data-id="element-670" /> : <ArrowUpIcon size={20} className="text-red-500" data-id="element-671" />}
                  </div>
                  <div className="flex-1" data-id="element-672">
                    <p className="font-medium" data-id="element-673">{transaction.description}</p>
                    <p className="text-sm text-white text-opacity-70" data-id="element-674">
                      {new Date(transaction.date).toLocaleDateString()}
                    </p>
                  </div>
                  <div className={`font-semibold ${transaction.amount > 0 ? 'text-green-500' : 'text-primary'}`} data-id="element-675">
                    {transaction.amount > 0 ? '+' : ''}
                    {activeWallet.currency}{' '}
                    {Math.abs(transaction.amount).toFixed(2)}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      <BottomNav data-id="element-676" />
    </div>;
};